import { convertToExportedView } from '@estee/elc-service';
import { serviceNames } from '~setup/OffersService';
import { ISamplesSetComponentProps } from './SamplesSetComponent';

// eslint-disable-next-line no-restricted-syntax
export default convertToExportedView<ISamplesSetComponentProps>(
    // @ts-ignore
    () => import('./SamplesSetComponent'),
    'samplesComponent',
    serviceNames.offerCodeModuleViewController
);